export const adaptDisfagia = (disfagiaData) => {
    const { disfagiaRIByDatosGeneralesId: disfagia } = disfagiaData;

    return {
        programaDI1: {
            idDisfagiaRI: disfagia?.disfagiaRI?.idDisfagiaRI,
            videodeglucion: disfagia?.disfagiaRI?.videodeglucion,
            dIDisfagiaARI: disfagia?.disfagiaRI?.dIDisfagiaARI?.map(x => x.idComboRIValor),
            episodiosNeumonia: disfagia?.disfagiaRI?.episodiosNeumonia,
            dIAlimentacionActualRI: disfagia?.disfagiaRI?.dIAlimentacionActualRI?.map(x => x.idComboRIValor),
            dIHidratacionActualRI: disfagia?.disfagiaRI?.dIHidratacionActualRI?.map(x => x.idComboRIValor),
            traqueostomia: disfagia?.disfagiaRI?.traqueostomia,
            lucido: disfagia?.disfagiaRI?.lucido,
            compromisoMotor: disfagia?.disfagiaRI?.compromisoMotor,
            idComboRIValorKarnofsky: disfagia?.disfagiaRI?.idComboRIValorKarnofsky,
            videodeglucionAdjunto: {
                contentType: disfagia?.videodeglucionAdjunto?.contentType,
                archivo: disfagia?.videodeglucionAdjunto?.archivo,
                extension: disfagia?.videodeglucionAdjunto?.extension,
                titulo: disfagia?.videodeglucionAdjunto?.titulo,
            }
        },
        programaDI2: {
            idDisfagiaRI: disfagia?.disfagiaRI?.idDisfagiaRI,
            actividadMotoraAlAlimentarse: disfagia?.disfagiaRI?.actividadMotoraAlAlimentarse,
            controlCefalico: disfagia?.disfagiaRI?.controlCefalico,
            idComboRIValorControlPostural: disfagia?.disfagiaRI?.idComboRIValorControlPostural,
            idComboRIValorDenticion: disfagia?.disfagiaRI?.idComboRIValorDenticion,
            idComboRIValorProtesis: disfagia?.disfagiaRI?.idComboRIValorProtesis,
            idComboRIValorEvaluacionFonoaudiologica: disfagia?.disfagiaRI?.idComboRIValorEvaluacionFonoaudiologica,
            idComboRIValorModuloDisfagia: disfagia?.disfagiaRI?.idComboRIValorModuloDisfagia,
            idComboRIValorNadaPorBoca: disfagia?.disfagiaRI?.idComboRIValorNadaPorBoca,
            nadaPorBoca: disfagia?.disfagiaRI?.nadaPorBoca,
            justificacionNadaPorBoca: disfagia?.disfagiaRI?.justificacionNadaPorBoca,
            idComboRIValorHidratacion: disfagia?.disfagiaRI?.idComboRIValorHidratacion,
            idComboRIValorLiquidosEspesadosConConsistencia: disfagia?.disfagiaRI?.idComboRIValorLiquidosEspesadosConConsistencia,
            requiereNutricionEnteral: disfagia?.disfagiaRI?.requiereNutricionEnteral,
        }

    }
}